import dayjs from "dayjs";
import { isValidPhoneNumber } from "libphonenumber-js";

import { ValidationMessages } from "../backend/types/utils";
import i18n from "../services/i18n";
import { isEmptyObject, prune } from "./utility";

export const errorMessages = {
  [ValidationMessages.REQUIRED]: i18n.t("Required"),
  [ValidationMessages.INVALID]: i18n.t("Invalid"),
  [ValidationMessages.MINIMUM]: i18n.t("Minimum is"),
  [ValidationMessages.MAXIMUM]: i18n.t("Maximum is"),
  [ValidationMessages.NOTMATCHING]: i18n.t("Not matching"),
};

export class CustomValidationArguments {
  keys: Array<string> = [];
  errors: any = {};
  values: any = {};
  allowedKeys: Array<string> = [];
  errorMessage = "Required";
  isValid: (data: any) => boolean = () => true;

  constructor(obj: any) {
    obj && Object.assign(
      this,
      prune(obj)
    );
  }
}

export const validateRequiredNotDefault = (
  errors: any,
  required: any,
  values: any,
  defaults: any,
  keys: Array<string>,
  errorMessage = "Required",
): any => {
  Object.keys(required).forEach((key) => {
    if (keys.includes(key)) {
      if (Array.isArray(values[key])) {
        values[key].forEach((
          element: any, index: number
        ) => {
          if (typeof values[key][index] === 'object') {
            const computedErrors = validateRequiredNotDefault(
              {},
              required[key][index],
              values[key][index],
              defaults[key][index],
              Object.keys(required[key][index]),
              errorMessage,
            );

            if (!isEmptyObject(computedErrors)) {
              if (errors[key] === undefined) {
                errors[key] = [];
              }

              errors[key][index] = computedErrors;
            }
          } else if (required[key][index]) {
            if (element === null || element === defaults[key][index] || element === undefined || element === "") {
              if (errors[key] === undefined) {
                errors[key] = [];
              }

              errors[key][index] = errorMessage;
            }
          }
        });
      } else if (typeof values[key] === 'object') {
        const computedErrors = validateRequiredNotDefault(
          {},
          required[key],
          values[key],
          defaults[key],
          Object.keys(required[key]),
          errorMessage,
        )

        if (!isEmptyObject(computedErrors)) {
          errors[key] = computedErrors;
        }
      } else if (required[key]) {
        if (values[key] === null || values[key] === undefined || values[key] === "" || values[key] === defaults[key]) {
          errors[key] = errorMessage;
        }
      }
    }
  });

  return errors;
};

export const validateCustomData = ({
  keys,
  errors,
  values,
  allowedKeys,
  errorMessage,
  isValid
}: CustomValidationArguments) => {
  allowedKeys = Array.from(allowedKeys);

  keys.forEach((key) => {
    if (allowedKeys.includes(key) && !isValid(values[key])) {
      errors[key] = errorMessage;
    }
  });

  return errors;
}

export const validateCellphones = (args: CustomValidationArguments) => validateCustomData({
  ...args,
  isValid: (data: string): boolean => !!data && isValidPhoneNumber(data)
});

export const validateBooleansTrue = (args: CustomValidationArguments) => validateCustomData({
  ...args,
  isValid: (data: boolean): boolean => data
});

export const validateDates = (args: CustomValidationArguments) => validateCustomData({
  ...args,
  isValid: (data: any): boolean => data && dayjs(data).isValid()
});

export interface InRangeInfo {
  key: string;
  max?: number;
  min?: number;
}

export const validateNumberInRange = (
  info: InRangeInfo,
  errors: any,
  values: any,
  minErrorMessage: string,
  maxErrorMessage: string,
) => {
  const {
    key, min, max
  } = info;

  if (min !== null && min !== undefined && values[key] < min) {
    errors[key] = minErrorMessage + " " + min;
  } else if (max !== null && max !== undefined && values[key] > max) {
    errors[key] = maxErrorMessage + " " + max;
  }
};

export const validateNumbersInRange = (
  infos: Array<InRangeInfo>,
  errors: any,
  values: any,
  allowedKeys: any,
  minErrorMessage: string,
  maxErrorMessage: string,
) => {
  infos.forEach(info => {
    if (allowedKeys.includes(info.key)) {
      validateNumberInRange(
        info,
        errors,
        values,
        minErrorMessage,
        maxErrorMessage,
      );
    }
  });
}